import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useModelInfo } from '../common/ModelInfoContext';
import TrimWithFiltering from './withTrimFiltering/Trims';
import TrimWithoutFiltering from './withoutTrimFiltering/Trims';
import ConfigPage from './ConfigPage';

const Trims = props => {
  const { config, matrix, appResources, disclaimer, breakpoint } = props;
  const {
    enableTrimFiltering,
    enableTrimFilterGrouping,
    enableConfigStep,
    enableTrimCompare,
    isDefaultRenderMode
  } = useModelInfo();
  const { driveTypes, engines, styles, styleId, selections } = config;

  const disableConfigStep = !enableConfigStep;
  const hideEnginesAndDriveTypes =
    (enableTrimFiltering || disableConfigStep) && isDefaultRenderMode;

  return (
    <ConfigPage routeName="TRIM">
      {({ onChange, onTrimFilteringChange, onDetails }) => (
        <React.Fragment>
          {enableTrimFiltering ? (
            <TrimWithFiltering
              filterByConfig={enableConfigStep}
              matrix={matrix}
              config={config}
              disclaimer={disclaimer}
              appResources={appResources}
              breakpoint={breakpoint}
              disableCompare={!enableTrimCompare}
              enableTrimFilterGrouping={enableTrimFilterGrouping}
              onChange={onTrimFilteringChange}
            />
          ) : (
            <TrimWithoutFiltering
              engines={hideEnginesAndDriveTypes ? engines : []}
              driveTypes={hideEnginesAndDriveTypes ? driveTypes : []}
              styles={styles}
              styleId={styleId}
              disclaimer={disclaimer}
              disableCompare={!enableTrimCompare}
              appResources={appResources}
              breakpoint={breakpoint}
              selections={selections}
              onChange={onChange}
              onDetails={onDetails}
            />
          )}
        </React.Fragment>
      )}
    </ConfigPage>
  );
};

const mapStateToProps = state => {
  const { config, disclaimers, matrix, breakpoint, appResources } = state;
  const disclaimer = disclaimers.simple;
  return {
    config,
    matrix,
    breakpoint,
    disclaimer,
    appResources
  };
};

export default withRouter(connect(mapStateToProps)(Trims));
